module.exports = __webpack_public_path__ + "static/media/26UNRWA22.e3dd712b.jpg";